import { apiGet, apiPost } from '../api';
import { HOST } from '../config';
import { fetchGetOrderById } from './orders';
import { toast } from 'react-toastify';
import { parseError } from '../helpers';

export const A = {
  REQUEST_GET_DOCUMENTS: 'REQUEST_GET_DOCUMENTS',
  RECEIVE_GET_DOCUMENTS: 'RECEIVE_GET_DOCUMENTS',
  ERROR_GET_DOCUMENTS: 'ERROR_GET_DOCUMENTS',

  REQUEST_POST_EXPORT: 'REQUEST_POST_EXPORT',
  RECEIVE_POST_EXPORT: 'RECEIVE_POST_EXPORT',
  ERROR_POST_EXPORT: 'ERROR_POST_EXPORT',

  REQUEST_POST_ADMIN_SIGN: 'REQUEST_POST_ADMIN_SIGN',
  RECEIVE_POST_ADMIN_SIGN: 'RECEIVE_POST_ADMIN_SIGN',
  ERROR_POST_ADMIN_SIGN: 'ERROR_POST_ADMIN_SIGN',

  REQUEST_POST_CLIENT_SIGN: 'REQUEST_POST_CLIENT_SIGN',
  RECEIVE_POST_CLIENT_SIGN: 'RECEIVE_POST_CLIENT_SIGN',
  ERROR_POST_CLIENT_SIGN: 'ERROR_POST_CLIENT_SIGN',

  REQUEST_REJECT_CLIENT_SIGN: 'REQUEST_REJECT_CLIENT_SIGN',
  RECEIVE_REJECT_CLIENT_SIGN: 'RECEIVE_REJECT_CLIENT_SIGN',
  ERROR_REJECT_CLIENT_SIGN: 'ERROR_REJECT_CLIENT_SIGN',

  REQUEST_GET_HISTORY: 'REQUEST_GET_HISTORY',
  RECEIVE_GET_HISTORY: 'RECEIVE_GET_HISTORY',
  ERROR_GET_HISTORY: 'ERROR_GET_HISTORY',

  REQUEST_GET_STATUSES: 'REQUEST_GET_STATUSES',
  RECEIVE_GET_STATUSES: 'RECEIVE_GET_STATUSES',
  ERROR_GET_STATUSES: 'ERROR_GET_STATUSES',

  REQUEST_GET_FILE_CLIENT_SIGN: 'REQUEST_GET_FILE_CLIENT_SIGN',
  RECEIVE_GET_FILE_CLIENT_SIGN: 'RECEIVE_GET_FILE_CLIENT_SIGN',
  ERROR_GET_FILE_CLIENT_SIGN: 'ERROR_GET_FILE_CLIENT_SIGN',
};

/*Получение данных по документам   */

const requestGetDocuments = () => {
  return {
    type: A.REQUEST_GET_DOCUMENTS,
  };
};

const receiveGetDocuments = (data) => {
  return {
    type: A.RECEIVE_GET_DOCUMENTS,
    data,
  };
};

const errorGetDocuments = (err) => {
  return {
    type: A.ERROR_GET_DOCUMENTS,
    err,
  };
};

export const fetchGetDocuments = (data) => {
  const {
    id,
    date_from,
    date_to,
    updated_from,
    sortBy,
    purchaseOrderDocID,
    statuses,
    page,
    size = 15,
    doc_types,
  } = data;

  let url = `${HOST}/api/lite/jur_doc?size=${size}`;
  if (id) url += `&purchaseOrderDocID=${id}`;
  if (doc_types) url += `&doc_types=${doc_types}`;
  if (date_from) url += `&date_from=${date_from}`;
  if (date_to) url += `&date_to=${date_to}`;
  if (updated_from) url += `&updated_from=${updated_from}`;
  if (sortBy) url += `&sortBy=${sortBy}`;
  if (purchaseOrderDocID) url += `&purchaseOrderDocID=${purchaseOrderDocID}`;
  if (statuses) url += `&statuses=${statuses}`;
  if (page) url += `&page=${page}`;

  return (dispatch, getState) => {
    dispatch(requestGetDocuments());
    return apiGet({
      url,
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetDocuments(res));
        } else {
          dispatch(errorGetDocuments('Ошибка получения документов'));
        }
      },
      error: (err) => {
        dispatch(errorGetDocuments(err));
      },
    });
  };
};

/*Post-Запрос на получение экспорта*/

const requestPostExport = () => {
  return {
    type: A.REQUEST_POST_EXPORT,
  };
};

const receivePostExport = (data) => {
  return {
    type: A.RECEIVE_POST_EXPORT,
    data,
  };
};

const errorPostExport = (err) => {
  return {
    type: A.ERROR_POST_EXPORT,
    err,
  };
};

export const fetchExportDocuments = (data) => {
  let url = `${HOST}/api/lite/export/jur_doc`;
  return (dispatch, getState) => {
    dispatch(requestPostExport());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            toast.info('Экспорт произведен успешно');
            dispatch(receivePostExport());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostExport(err));
            toast.error(parseError(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorPostExport(err));
          reject(err);
        },
      });
    });
  };
};

/*Подписание документа админом*/

const requestPostAdminSign = () => {
  return {
    type: A.REQUEST_POST_ADMIN_SIGN,
  };
};

const receivePostAdminSign = (data) => {
  return {
    type: A.RECEIVE_POST_ADMIN_SIGN,
    data,
  };
};

const errorPostAdminSign = (err) => {
  return {
    type: A.ERROR_POST_ADMIN_SIGN,
    err,
  };
};

export const fetchAdminSign = (data) => {
  let url = `${HOST}/api/lite/admin/jur_doc/performer/sign`;
  return (dispatch, getState) => {
    dispatch(requestPostAdminSign());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            toast.info(`Документ подписан`);
            dispatch(receivePostAdminSign());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };

            toast.error(parseError(err));
            dispatch(errorPostAdminSign(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorPostAdminSign(err));
          reject(err);
        },
      });
    });
  };
};

/*Подписание документа клиентом*/

const requestPostClientSign = () => {
  return {
    type: A.REQUEST_POST_CLIENT_SIGN,
  };
};

const receivePostClientSign = (data) => {
  return {
    type: A.RECEIVE_POST_CLIENT_SIGN,
    data,
  };
};

const errorPostClientSign = (err) => {
  return {
    type: A.ERROR_POST_CLIENT_SIGN,
    err,
  };
};

export const fetchClientSign = (data) => {
  let url = `${HOST}/api/lite/jur_doc/client/sign`;
  return (dispatch, getState) => {
    dispatch(requestPostClientSign());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            toast.info(`Подпись отправлена`);
            dispatch(receivePostClientSign());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(parseError(err));
            dispatch(errorPostClientSign(err));
            reject(err);
          }
        },
        error: (err) => {
          toast.error(parseError(err));
          dispatch(errorPostClientSign(err));
          reject(err);
        },
      });
    });
  };
};

/*Отказ от подписания документа клиентом*/

const requestRejectClientSign = () => {
  return {
    type: A.REQUEST_REJECT_CLIENT_SIGN,
  };
};

const receiveRejectClientSign = (data) => {
  return {
    type: A.RECEIVE_REJECT_CLIENT_SIGN,
    data,
  };
};

const errorRejectClientSign = (err) => {
  return {
    type: A.ERROR_REJECT_CLIENT_SIGN,
    err,
  };
};

export const fetchRejectClientSign = (data) => {
  let url = `${HOST}/api/lite/jur_doc/client/comment`;
  return (dispatch, getState) => {
    dispatch(requestPostClientSign());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: async (res) => {
          if (res.success) {
            toast.info(`Комментарий отправлен, успешный отказ`);
            dispatch(requestRejectClientSign());
            resolve(res);
          } else {
            toast.error(parseError(err));
            const err = { data: { errors: res.errors } };
            dispatch(receiveRejectClientSign(err));
            toast.error('Возникла ошибка, обратитесь в поддержку');
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRejectClientSign(err));
          toast.error('Возникла ошибка, обратитесь в поддержку');
          reject(err);
        },
      });
    });
  };
};

/*Получение истории по документу*/

const requestGetHistory = () => {
  return {
    type: A.REQUEST_GET_HISTORY,
  };
};

const receiveGetHistory = (data) => {
  return {
    type: A.RECEIVE_GET_HISTORY,
    data,
  };
};

const errorGetHistory = (err) => {
  return {
    type: A.ERROR_GET_HISTORY,
    err,
  };
};

export const fetchGetHistory = (id) => {
  let url = `${HOST}/api/lite/jur_doc/history?id=${id}`;
  return (dispatch, getState) => {
    dispatch(requestGetHistory());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetHistory());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetHistory(err));
            reject(err);
            toast.error('Возникла ошибка, обратитесь в поддержку');
          }
        },
        error: (err) => {
          dispatch(errorGetHistory(err));
          reject(err);
          toast.error('Возникла ошибка, обратитесь в поддержку');
        },
      });
    });
  };
};

/*Получение статусов для фильтра складских документов*/

const requestGetStatuses = () => {
  return {
    type: A.REQUEST_GET_STATUSES,
  };
};

const receiveGetStatuses = (data) => {
  return {
    type: A.RECEIVE_GET_STATUSES,
    data,
  };
};

const errorGetStatuses = (err) => {
  return {
    type: A.ERROR_GET_STATUSES,
    err,
  };
};

export const fetchGetStatuses = () => {
  let url = `${HOST}/api/lite/jur_doc/statuses`;
  return (dispatch, getState) => {
    dispatch(requestGetStatuses());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetStatuses());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetStatuses(err));
            reject(err);
            toast.error('Возникла ошибка, обратитесь в поддержку');
          }
        },
        error: (err) => {
          dispatch(errorGetStatuses(err));
          reject(err);
          toast.error('Возникла ошибка, обратитесь в поддержку');
        },
      });
    });
  };
};

export const fetchGetFileClientSign = (id) => {
  let url = `${HOST}/api/lite/jur_doc/content?id=${id}`;
  return (dispatch, getState) => {
    dispatch(requestGetFileClientSign());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        customHeaders: {
          Accept: 'application/text;charset=UTF-8',
        },
        callback: (res) => {
          if (res) {
            dispatch(receiveGetFileClientSign());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetStatuses(err));
            reject(err);
            toast.error('Возникла ошибка, обратитесь в поддержку');
          }
        },
        error: (err) => {
          dispatch(errorGetFileClientSign(err));
          reject(err);
          toast.error('Возникла ошибка, обратитесь в поддержку');
        },
      });
    });
  };
};
const requestGetFileClientSign = () => {
  return {
    type: A.REQUEST_GET_FILE_CLIENT_SIGN,
  };
};

const receiveGetFileClientSign = (data) => {
  return {
    type: A.RECEIVE_GET_FILE_CLIENT_SIGN,
    data,
  };
};

const errorGetFileClientSign = (err) => {
  return {
    type: A.ERROR_GET_FILE_CLIENT_SIGN,
    err,
  };
};
